
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 31 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.2 10.9a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M27.6 15.3c3.2-3.2 3.2-8.4 0-11.6C24.4.5 19.2.5 16 3.7c-2.5 2.5-3.1 6.3-1.6 9.4L1.1 26.4v3.9l7.5-.1v-3.5H12l.1-3.6 3.6-.1v-3.4l2.6-2.6c3.1 1.4 6.8.8 9.3-1.7z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    